module.exports = __webpack_public_path__ + "media/fonts/IntroBold-d66122fb.woff";